import Vue from "vue";
import vueshortkey from "vue-shortkey";

Vue.use(vueshortkey);

export default vueshortkey;
